export const environment = {
  production: true,
  baseURL: 'api/rest/s1',
  baseWebSocketURL: 'api/notws',
  invoiceRegisterUrl: '/invoice-register/',
  firebaseConfig : {
    apiKey: "AIzaSyBDPuffHZxQlGtVnsZHx2PhCYc8YrnSfr0",
    authDomain: "testfirebase-68268.firebaseapp.com",
    projectId: "testfirebase-68268",
    storageBucket: "testfirebase-68268.firebasestorage.app",
    messagingSenderId: "1006534388356",
    appId: "1:1006534388356:web:4cfd548b08a62cd86d30d1",
    measurementId: "G-P96T418BWL"
  }
};
